import React from 'react';

/** Carte d'une étape décision en exécution : question + choix (le badge est rendu par la timeline). */
export default function WorkflowDecisionStep({ node, chosenAnswerId, busy, readOnly, onAnswer }) {
  const answers = node.answers || [];
  return (
    <div className="wf-card decision">
      <div className="wf-card-head">
        <span className="wf-type decision">Décision</span>
        <span className="wf-card-title">{node.question || 'Décision'}</span>
      </div>
      <div className="wf-answers">
        {answers.map((a) => {
          const on = a.id === chosenAnswerId;
          return (
            <button key={a.id} className={`wf-choice ${on ? 'on' : ''}`}
              style={on ? { background: a.color, borderColor: a.color } : { borderColor: a.color, color: a.color }}
              disabled={busy || readOnly} onClick={() => onAnswer(on ? null : a.id)} title={on ? 'Annuler ce choix' : ''}>
              {on ? '✓ ' : ''}{a.label || 'réponse'}
            </button>
          );
        })}
      </div>
    </div>
  );
}
